module.exports = __webpack_public_path__ + "img/cj01.9815b6b5.jpg";